import { useTranslation } from "react-i18next"

import "./UnderConstruction.css"

/* A pick at work on a building with a level ordered this round (owner, 2026-10-02: "We need a small
   emoti when a building is under construction"; 2026-10-03: "an emoti of a pick moving like it's
   building"). A level is an order that lands when the round turns, so the mark says the level is
   coming and when. Whether a building has one is `utils/pendingOrders.upgradeOrderedAt`, through
   `cellActions.upgradeOrdersFor`'s `ordered`; this only draws it. `level` is the level that lands.

   `decorative` is for a place that already says it in words (the building sheet's button): the
   pick is hidden from assistive technology there, so the button is not named twice. */
const UnderConstruction = ({ level, className = "", decorative = false, style }) => {
  const { t } = useTranslation()
  const label = t("city.underConstruction", { level })
  const named = decorative ? { "aria-hidden": "true" } : { role: "img", "aria-label": label, title: label }
  return (
    <span className={`under-construction ${className}`.trim()} style={style} {...named}>
      {/* Drawn, not the ⛏️ emoji (owner, 2026-10-03: "the same color as the MEJORANDO (orange)"):
          an emoji is the platform's own picture and colour, so the pick is a vector in
          `currentColor`, set to the band's --amber in the stylesheet. Head top right and grip
          bottom left — the emoji mirrored (owner, 2026-10-04: *"the pick hits to the left in the
          map, and it looks like it's building the other cell"*), so the strike lands on the right,
          inside the cell it marks. */}
      <svg className="under-construction-pick" data-testid="under-construction-pick" viewBox="0 0 24 24" aria-hidden="true">
        <g transform="translate(24 0) scale(-1 1)">
          <path d="M8.5 8.5 L20.5 20.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
          <path d="M1.6 14 Q3.2 3.2 14 1.6 Q8.4 4.4 7.1 7.1 Q4.4 8.4 1.6 14 Z" fill="currentColor" />
          <path d="M19.2 19.2 L21.4 21.4" stroke="currentColor" strokeOpacity="0.55" strokeWidth="3.4" strokeLinecap="round" />
        </g>
      </svg>
    </span>
  )
}

export default UnderConstruction
